export default function Gallery() {
  const images = [
    {
      url: 'https://public.readdy.ai/ai/img_res/83e5cf631a71a980efbd15761591972a.jpg',
      label: 'Formularios OMR'
    },
    {
      url: 'https://public.readdy.ai/ai/img_res/edited_d5d621f1e6b89b66a03c2fa1deb5a28c_987b4bf4.jpg',
      label: 'Escaneo Digital'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=computer%20screen%20displaying%20educational%20data%20analytics%20dashboard%20with%20colorful%20charts%20graphs%20and%20statistics%2C%20modern%20office%20workspace%2C%20professional%20business%20intelligence%20software%20for%20education%2C%20clean%20organized%20interface%2C%20warm%20teal%20and%20amber%20ambient%20lighting&width=700&height=500&seq=gallery-dashboard-warm-v2&orientation=landscape',
      label: 'Análisis de Datos'
    }
  ];

  return (
    <section id="gallery" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 bg-[#0D9488]/10 px-5 py-2 rounded-full mb-4">
            <i className="ri-camera-line text-[#0D9488]"></i>
            <span className="text-[#0D9488] font-semibold text-sm">Nuestro Trabajo</span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1A1A2E] mb-3 md:mb-4 px-4">
            Tecnología <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0D9488] to-[#F59E0B]">en Acción</span>
          </h2>
          <p className="text-base md:text-lg text-gray-500 max-w-2xl mx-auto px-4">
            Conoce nuestro proceso y tecnología de evaluación automatizada
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="relative group overflow-hidden rounded-3xl shadow-xl cursor-pointer">
            <div className="w-full h-[350px] md:h-[500px]">
              <img 
                src={images[0].url}
                alt={images[0].label}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-[#1A1A2E]/80 via-[#1A1A2E]/30 to-transparent opacity-100 group-hover:opacity-70 transition-opacity"></div>
            <div className="absolute bottom-6 left-6 bg-[#0D9488]/90 backdrop-blur-sm px-5 py-2.5 rounded-lg">
              <p className="text-white font-semibold text-sm">{images[0].label}</p>
            </div>
          </div>

          <div className="space-y-6">
            {images.slice(1).map((image, index) => (
              <div key={index} className="relative group overflow-hidden rounded-3xl shadow-xl cursor-pointer">
                <div className={`w-full ${index === 0 ? 'h-[420px] sm:h-[480px] md:h-[237px]' : 'h-[350px] md:h-[237px]'}`}>
                  <img 
                    src={image.url}
                    alt={image.label}
                    className={`w-full h-full ${index === 0 ? 'object-contain object-center bg-gray-50' : 'object-cover object-center'} transition-transform duration-500 group-hover:scale-110`}
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-[#1A1A2E]/80 via-[#1A1A2E]/30 to-transparent opacity-100 group-hover:opacity-70 transition-opacity"></div>
                <div className="absolute bottom-6 left-6 bg-[#F59E0B]/90 backdrop-blur-sm px-5 py-2.5 rounded-lg">
                  <p className="text-white font-semibold text-sm">{image.label}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}